// extracted by mini-css-extract-plugin
export default {"root":"CsvModal_root__ZyocQ","separatorLabel":"CsvModal_separatorLabel__4dPoa","list":"CsvModal_list__coHAd","wrong":"CsvModal_wrong__eXcSG","errorText":"CsvModal_errorText__BR+wO"};